import React from 'react'

function Hashtags() {
    return (
        <div className="hashtags-container">
            <ul>
                <li>#front-end</li>
                <li>#web-developer</li>
                <li>#web-designer</li>
                <li>#vancouver</li>
                <li>#html&css</li>
                <li>#web-scripting</li>
                <li>#design</li>
                <li>#graphics</li>
                <li>#animation</li>
            </ul>
        </div>
    )
}

export default Hashtags
